export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  EMPLOYEE = 'ROLE_EMPLOYEE',
  USER = 'ROLE_USER'
}
